import { Organisation } from "@/api/SolarCloudApi";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect } from "react";

type ExistingOrganisationsProps = {
  selectedOrganisation: Organisation | null;
  organisations: Organisation[];
  setOrganisation: (organisation: Organisation | null) => void;
};

export default function ExistingOrganisations({
  selectedOrganisation,
  organisations,
  setOrganisation,
}: ExistingOrganisationsProps) {
  const handleSelect = (uuid: string) => {
    const selected = organisations.find((org) => org.uuid === uuid);
    setOrganisation(selected ?? null);
  };

  useEffect(() => {
    if (selectedOrganisation) {
      setOrganisation(selectedOrganisation);
    }
  }, [selectedOrganisation, setOrganisation]);

  return (
    <Select
      value={selectedOrganisation?.uuid || ""}
      onValueChange={(uuid) => {
        handleSelect(uuid);
      }}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select an existing organisation" />
      </SelectTrigger>
      <SelectContent>
        {organisations.map((organisation) => (
          <SelectItem key={organisation.uuid} value={organisation.uuid!}>
            {organisation.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
